import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { WorkflowTransition } from "../../../models/request/workflow-transition";
import { SetCommentModel } from "../set-comment/set-comment.model";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { RequestResultSettingsService } from "../../../services/request-result-settings.service";

@Component({
    selector: 'transition-confirmation-request',
    templateUrl: './transition-confirmation-request.component.html',
    styleUrls: ['../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class TransitionConfirmationRequestComponent implements OnInit {

    @Output()
    onContinueEvent = new EventEmitter<SetCommentModel>();

    @Input()
	workflowTransition: WorkflowTransition;

    @Input()
	setCommentModel: SetCommentModel;

    @Input()
    requestTypeId: number;

    @Input()
    customerContragentId: number;

    @Input()
    requestId: number;

    dataSaving: boolean = false;
    textArray: string[] = [];

    requestResults: KeyValueObject[] = [];
    selectedRequestResultId: number = null;

    constructor(
        public dialog: DialogRef,
        private requestResultSettingsService: RequestResultSettingsService
    ) {

    }

    get cardHeight(): number {
        return window.innerHeight - 800;
    }

    get showRequestResult(): boolean {
        return this.requestResults && this.requestResults.length > 0;
    }

    getTextArray(): void {
        if (!!!this.workflowTransition.warningText) {
            return;
        }

        this.textArray = this.workflowTransition.warningText.split("<br>");
    }

    ngOnInit() {
        this.getTextArray();
        this.loadRequestResults();
    }

    private loadRequestResults(): void {
        if (this.requestTypeId) {
            this.requestResultSettingsService.getByRequest(this.requestTypeId, this.customerContragentId)
                .subscribe(data => {
                    this.requestResults = data;
                });
        }
    }

    closeDialog() {
        if (this.dialog)
            this.dialog.close();
    }

    cancel() {
        this.closeDialog();
    }

    continue() {
        this.dataSaving = true;

        if (this.showRequestResult && this.selectedRequestResultId) {
            this.requestResultSettingsService.saveRequestResult(this.requestId, this.selectedRequestResultId)
                .subscribe(() => {
                    this.emitAndClose();
                });
        } else {
            this.emitAndClose();
        }
    }

    private emitAndClose(): void {
        if (this.onContinueEvent) {
            this.onContinueEvent.emit(this.setCommentModel);
        }

        this.dataSaving = false;
        this.closeDialog();
    }
}